import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { actions } from '../redux'
import { isServer } from '../../../utils'

const useViewPortEffect = (device: any) => {
  const dispatch = useDispatch()
  useEffect(() => {
    if (isServer() === false) {
      dispatch(
        actions.setViewPort({
          device,
          innerHeight: window.innerHeight,
          innerWidth: window.innerWidth
        })
      )
    }
  }, [dispatch, device])
}

export default useViewPortEffect
